import React from 'react';
export var CollapseContext = React.createContext({
    activeKeys: [],
});
//# sourceMappingURL=collapse-context.js.map